import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { Switcher } from "src/UI/Switcher";

interface QuestionToggleProps {
  question?: string;
  description?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  noLabel: string;
  yesLabel: string;
  disabled?: boolean;
}

const QuestionToggle: React.FC<QuestionToggleProps> = ({
  question,
  description,
  checked,
  onChange,
  noLabel,
  yesLabel,
  disabled = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {question && (
          <Typography
            sx={{
              fontSize: "1rem",
              color: theme.palette.text.primary,
            }}
          >
            {question}
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: checked ? 400 : 600,
              color: theme.palette.text.primary,
            }}
          >
            {noLabel}
          </Typography>
          <Switcher
            checked={checked}
            disabled={disabled}
            onChange={(_, next) => onChange(next)}
            sx={{ my: "-9px" }}
          />
          <Typography
            sx={{
              fontSize: "13px",
              fontWeight: checked ? 600 : 400,
              color: checked
                ? theme.palette.primary.main
                : theme.palette.text.primary,
            }}
          >
            {yesLabel}
          </Typography>
        </Box>
      </Box>
      {description && (
        <Typography
          sx={{
            fontSize: "12px",
            color: theme.palette.text.tertiary,
            lineHeight: "1rem",
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default QuestionToggle;
